<script lang="ts" setup>
import './register'
import { setDefaultLoadingRender } from '@overseas/tcdesign'
import { configurable as requestConfigurable } from '@overseas/request'
import { useCommonConfig } from '~/store/common'
import { InitApp } from '~/utils/initApp'
import { useFetch } from '#app'
import '@overseas/tcdesign/dist/style.css'
import BtnLoading from '~/components/btn-loading/index.vue'

import { useSMFingerprint } from '~/composables/useSMFingerprint'

const runtimeConfig = useRuntimeConfig()

InitApp()

requestConfigurable({
  baseUrl: ['stage', 'qa', 'dev'].includes(runtimeConfig.public.envType) ? '//app.t.hopegoo.com' : '//app.hopegoo.com',
} as any)

const config = useRuntimeConfig()
const buildTime = config.public.buildTime
const envType = config.public.envType

useHead({
  script: [
    {
      src: '//res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js',
      defer: true,
    },
    {
      src: '//file.reshg.com/dunos/dun/pd/dun.min.1.1.4.5.js',
      crossorigin: 'anonymous',
      async: true,
    },
  ],
})

useSMFingerprint()

if (import.meta.client) {
  // eslint-disable-next-line no-console
  console.log(
    `%c[BuildTime]: ${buildTime}`,
    'color: #01875f; font-size: 1.5em; font-weight: bold;',
  )
}

setDefaultLoadingRender((props: any) => {
  return h(BtnLoading, props)
})

const { locale, mergeLocaleMessage } = useI18n()
const htmlLang = computed(() => {
  if (locale.value === 'en-xx' || locale.value === 'en-hk') {
    return 'en'
  }
  if (locale.value === 'zh-hk') {
    return 'zh-HK'
  }
  return locale.value
})

try {
  const { data } = await useFetch('/_fapi/fetchLatestI18', {
    method: 'POST',
    body: JSON.stringify({ lang: locale.value === 'en-xx' ? 'en-us' : locale.value }),
  })

  if (data && data.value) {
    mergeLocaleMessage(locale.value, data.value)
  }
}
catch (error) {
  console.warn('apply 语言包失败', error)
}

const commonConfig = useCommonConfig()
if (process.client) {
  commonConfig.getCommonConfig()
}
</script>

<template>
  <Html :lang="htmlLang">
    <Body class="min-h-screen antialiased text-gray-800 transition-colors duration-300 bg-white w-max-full">
      <NuxtLayout>
        <NuxtPage />
      </NuxtLayout>
    </Body>
  </Html>
</template>

<style lang="scss">
@use "~/assets/css/element-theme.scss";
@use "~/assets/css/base/main.scss";

body {
  min-width: 1190px;
}
</style>
